/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscountTypeEnum } from './DiscountTypeEnum';
import {
    DiscountTypeEnumFromJSON,
    DiscountTypeEnumFromJSONTyped,
    DiscountTypeEnumToJSON,
    DiscountTypeEnumToJSONTyped,
} from './DiscountTypeEnum';

/**
 * 
 * @export
 * @interface Discount
 */
export interface Discount {
    /**
     * 
     * @type {number}
     * @memberof Discount
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    title: string;
    /**
     * 
     * @type {Date}
     * @memberof Discount
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof Discount
     */
    validTo: Date;
    /**
     * 
     * @type {number}
     * @memberof Discount
     */
    discount: number;
    /**
     * 
     * @type {DiscountTypeEnum}
     * @memberof Discount
     */
    discountType: DiscountTypeEnum;
}



/**
 * Check if a given object implements the Discount interface.
 */
export function instanceOfDiscount(value: object): value is Discount {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    if (!('validTo' in value) || value['validTo'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('discountType' in value) || value['discountType'] === undefined) return false;
    return true;
}

export function DiscountFromJSON(json: any): Discount {
    return DiscountFromJSONTyped(json, false);
}

export function DiscountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Discount {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'validFrom': (new Date(json['validFrom'])),
        'validTo': (new Date(json['validTo'])),
        'discount': json['discount'],
        'discountType': DiscountTypeEnumFromJSON(json['discountType']),
    };
}

export function DiscountToJSON(json: any): Discount {
    return DiscountToJSONTyped(json, false);
}

export function DiscountToJSONTyped(value?: Discount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'validFrom': ((value['validFrom']).toISOString()),
        'validTo': ((value['validTo']).toISOString()),
        'discount': value['discount'],
        'discountType': DiscountTypeEnumToJSON(value['discountType']),
    };
}

